import React from "react";
import { useLang } from "@/i18n";
import { DotGrid, EqualMark, BarsMark } from "@/components/site/Marks";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/8 py-12 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
        <span className="font-serif-display text-xl text-[#f5f2eb]">Marián Hriňa</span>
        <div className="flex items-center gap-5 opacity-40">
          <BarsMark color="#f5f2eb" count={3} w={26} />
          <EqualMark color="#d97925" w={30} />
          <DotGrid color="#f5f2eb" cols={4} rows={3} gap={7} r={1.4} />
        </div>
        <span className="overline text-[#8d8a83]">
          © {new Date().getFullYear()} — {t("footer.rights")}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
